<app-top-nav-registration></app-top-nav-registration>
<div class="container">
  <div class="content" role="main">
    <div class="h-30"></div>
    <div class="facility-heading">{{ 'sgpFinalHeading' | translate:translations }}</div>
    <div class="designatedFacilityForm">
      <form>
        <app-registration-form [createuserobj]="createuserobj" [isSubmitted]="isSubmitted"></app-registration-form>
        <div class="form-fields">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{ 'sgpRegProvinceLabel' | translate:translations }}</mat-label>
            <mat-select [placeholder]="'sgpFinalProvinceSelect' | translate:translations" name="province" [(ngModel)]="createuserobj.province" [disabled]="provincePrefilled">
              @for (p of provinces; track p) {
                <mat-option [value]="p.id">{{p.provinceName}}</mat-option>
              }
            </mat-select>
            <mat-hint>{{ 'sgpRegProvinceHint' | translate:translations }}</mat-hint>
          </mat-form-field>
          @if (isSubmitted && !createuserobj.province) {
            <mat-error class="registration-validation-error">{{ 'sgpRegProvinceRequired' | translate:translations }}</mat-error>
          }
          <div class="mb-10"></div>
        </div>
        <div class="form-buttons">
          <button type="button" class="submit-form-button" (click)="onSubmit()">{{ 'sgpRegSubmit' | translate:translations }}</button>
        </div>
      </form>
    </div>
  </div>
</div>
<app-footer></app-footer>
